import { render, staticRenderFns } from "./ManageEcosystemsAccess.vue?vue&type=template&id=a1b97e60&scoped=true&"
import script from "./ManageEcosystemsAccess.vue?vue&type=script&setup=true&lang=js&"
export * from "./ManageEcosystemsAccess.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b97e60",
  null
  
)

export default component.exports